export function getPayeeRulesV4(send) {
  return (...args) =>
    send(
      {
        path: '/v4/payees/rules',
        pathParameters: {},
        type: 'get',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: undefined,
        contentType: undefined,
      },
      ...args
    );
}
